import { render, staticRenderFns } from "./DnNumberInput.vue?vue&type=template&id=80d288f4"
import script from "./DnNumberInput.vue?vue&type=script&lang=js"
export * from "./DnNumberInput.vue?vue&type=script&lang=js"
import style0 from "./DnNumberInput.vue?vue&type=style&index=0&id=80d288f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports